// What a whole page shows while it (or its first read) loads: a header and a
// body block, FULL WIDTH.
//
// ⚠ Not a spinner. A page that returned a bare spinner drew a small ring at
// the content area's top-left and then the page "jumped" to full width (user,
// 2026-09-30); a reload already shows one spinner (the session check), so a
// second read as the page loading twice. Header + body is the shape every page
// shares, so the page that replaces this lands in the same place.
import * as stylex from '@stylexjs/stylex';
import '@tokens/spacing.stylex';
import { spacing } from '@tokens/spacing.stylex';
import { Skeleton } from './skeleton';
export function PageSkeleton() {
  return <div className="xh8yej3 x78zum5 xdt5ytf x1mnnc3i" aria-busy="true">
      <Skeleton width="240px" height="28px" />
      <Skeleton width="min(480px, 80%)" height="14px" />
      <div className="xv1leuy">
        <Skeleton height="320px" />
      </div>
    </div>;
}